import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import 'rxjs/add/operator/map';
import { environment } from '../../environments/environment';
import { AuthenticationService } from './authentication.service';
import { Utils } from '../class/utils';
import { Observable } from 'rxjs/Observable';
@Injectable({
  providedIn: 'root'
})
export class DigiCodService {

  constructor(private http: HttpClient, private authenSrv: AuthenticationService) { }

  getDigicodFromBack(){
    let url=environment.apiUrl+ this.authenSrv.getUserApiTargetUrl() +'/digicodes';
    return this.http.get<any>(url);
  }
  getDigicodByIdFromBack(id: string){
    let url=environment.apiUrl+ this.authenSrv.getUserApiTargetUrl() +'/digicodes/'+id;
    return this.http.get<any>(url);
  }

  saveDigicod(digicode){
    let url=environment.apiUrl+ this.authenSrv.getUserApiTargetUrl() +'/digicodes';
    let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    return this.http.put<any>(url,digicode,{headers ,withCredentials: true});
  }
  createDigicod(digicode){
    let url=environment.apiUrl+ this.authenSrv.getUserApiTargetUrl() +'/digicodes';
    let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    return this.http.post<any>(url,digicode,{headers , withCredentials: true});
  }
  forceOpen(digicode: string){
    let url = environment.apiUrl+ this.authenSrv.getUserApiTargetUrl() +'/control/forceOpen?equipmentId='+digicode;
    return this.http.get<any>(url,{withCredentials: true});
  }
  delete(id: string){
    let url = environment.apiUrl+ this.authenSrv.getUserApiTargetUrl() +'/digicodes/'+id;
    return this.http.delete<any>(url,{withCredentials: true});
  }
}
